<template>
  <div>
    <div class="modal-header">
      <h2>Upozorenje</h2>
    </div>
    <div class="modal-body">
      <p>
        Da li ste sigurni da želite da obrišete projekat:
      </p>
      <p class="filename">{{ project.project.title }}</p>
      <p>Svi tiketi koji nisu u statusu "Zatvoren" će takođe biti obrisani.</p>
    </div>
    <hr />
    <div class="footer">
      <button type="submit" class="btn btn-danger btn--mod" @click="closeModal">
        Otkaži
      </button>
      <button
        type="submit"
        class="btn btn-primary btn--mod"
        @click="deleteProject"
        :disabled="loading"
      >
        <span v-if="!loading">Potvrdi</span>
        <spinner line-fg-color="#00796b" v-if="loading" />
      </button>
    </div>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  computed: {
    ...mapState('modal', ['project']),
    ...mapState(['loading'])
  },
  methods: {
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapMutations('modal', ['closeModal', 'showModal']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapActions('table', ['getAllProjects']),
    deleteProject() {
      if (this.loading) {
        return;
      }
      this.loadingStarted();
      axios
        .delete(`project/${this.project.project.id}`)
        .then(async () => {
          if (this.$router.history.current.name == 'projectDetails') {
            this.$router.push({
              name: 'projects'
            });
          } else {
            await this.getAllProjects();
          }

          this.loadingFinished();
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(e => {
          console.log('eer', e);
          this.loadingFinished();
          this.showFailModal();
        });
    }
  }
};
</script>

<style scoped>
.filename {
  word-break: break-word;
}
</style>
